<hr class="mb-2 mx-4 border-t border-0 border-surface-600" />

<div class="flex flex-col gap-2 px-2 pb-2">
  @if (!hideUpgradeButton() && showUpgradeButton()) {
    <div class="px-2 pt-2">
      <a pButton [href]="upgradeUrl()" class="w-full" severity="contrast">
        <i pButtonIcon class="{{ PrimeIcons.STAR }}"></i>
        <span pButtonLabel>Upgrade to Pro</span>
      </a>
    </div>
  }
  <dt-sidebar-menu></dt-sidebar-menu>
</div>
